//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Nav from '@/components/nav.vue';
import CourseResource from '@/components/courseItemResource.vue';
import { resolveFileUrl as fileUrl } from '@/libs/fileUrl';
import { majorInfoWebGet, majorInfoCourseWebList } from '@/api/virtualSimulationClass/index';
export default {
  name: 'ProfessionalTeachingCourse',
  components: {
    Nav: Nav,
    CourseResource: CourseResource
  },
  data: function data() {
    return {
      libraryId: this.$route.query.libraryId || '',
      library: {},
      courseName: '',
      courseList: [],
      total: 0,
      loading: false,
      query: {
        majorInfoId: this.$route.query.libraryId || '',
        pageNum: 1,
        pageSize: 12
      }
    };
  },
  created: function created() {
    if (!this.libraryId) {
      this.$message.error('缺少资源库信息');
      return;
    }
    this.getLibrary();
    this.getList();
  },
  methods: {
    fileUrl: fileUrl,
    getLibrary: function getLibrary() {
      var _this = this;
      return majorInfoWebGet({
        id: this.libraryId
      }).then(function (res) {
        _this.library = (res && res.id ? res : res && res.data) || {};
      });
    },
    getList: function getList() {
      var _this2 = this;
      if (!this.libraryId) return;
      this.loading = true;
      majorInfoCourseWebList({
        majorInfoId: this.libraryId,
        name: this.courseName,
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize
      }).then(function (res) {
        if (res.code == 200) {
          _this2.courseList = res.rows || [];
          _this2.total = res.total || 0;
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    search: function search() {
      this.query.pageNum = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.query.pageNum = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.query.pageSize = size;
      this.query.pageNum = 1;
      this.getList();
    },
    goBack: function goBack() {
      this.$router.push('/professionalTeaching');
    }
  }
};